import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import BeatLoader from "react-spinners/BeatLoader";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
  Button,
  CustomInput,
  Description,
  SubTitle,
} from "../../Components/CustomComponents";
import AccountLayout from "../../Components/Layouts/AccountLayout";
import { WEB_ROUTES } from "../../constants";
import { storeToken } from "../../Data/services/localStorageService";
import { useLoginUserMutation } from "../../Data/services/userAuthApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import { ACCOUNT_ENUM } from "./Route";

export default function Login({ setPage }) {
  const [showPassword, setShowPassword] = useState(false);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  // const pagename = useSelector((state) => state.pagename.pagename);

  const handleForgotPasswordClick = () => {
    setPage(ACCOUNT_ENUM.FORGOT_PASSWORD);
  };

  const [loginUser, { isLoading }] = useLoginUserMutation();

  const handleLogin = async (data) => {
    data["device_type"] = "web";
    data["device_token"] = "123";
    // storeToken("token");
    // navigate(WEB_ROUTES.DASHBOARD);
    try {
      const response = await loginUser(data);

      // SetAuthUserLocalStorage(response?.data?.data);
      // SetTokenLocalStorage(response?.data?.data?.api_token);

      // console.log(response);

      if (response.error && !response.data) {
        Toast(response.error.data.message, "error");
      }
      if (!response.error && response.data.code === 200) {
        storeToken(response.data.data.api_token);
        SuccessToast(response?.data?.message);

        navigate(WEB_ROUTES.DASHBOARD);
      }

      // navigate("dashboard");
      // Toast(response?.data?.message, "success");
    } catch (error) {
      // console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
  };

  return (
    <AccountLayout>
      {errors
        ? errors.email?.message
          ? Toast(errors.email?.message, "error")
          : Toast(errors.password?.message, "error")
        : null}
      {
        // <Title text="Welcome to" classes="mb-2 fs-4" />
      }
      <SubTitle text="Admin Panel" classes="mb-2 text-black" />

      <Form onSubmit={handleSubmit(handleLogin)}>
        <Controller
          control={control}
          name="email"
          rules={{
            required: "Email is required.",
            pattern: {
              value: /\S+@\S+\.\S+/,
              message: "Enter a valid email address.",
            },
          }}
          render={({ field: { onChange, onBlur, value, ref } }) => (
            <InputGroup
              className="mb-3"
              style={{
                width: "300px",
              }}
            >
              <CustomInput
                placeholder="Email"
                type="email"
                onChange={onChange}
              />
            </InputGroup>
          )}
        />
        <Controller
          control={control}
          name="password"
          rules={{
            required: "Password is required.",
            minLength: {
              value: 3,
              message: "Minimum 3 characters long.",
            },
          }}
          render={({ field }) => (
            <InputGroup
              className="mb-3 "
              style={{
                width: "300px",
              }}
            >
              <div style={{ position: "relative", width: "100%" }}>
                <CustomInput
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  onChange={field.onChange}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: 12,
                    top: "50%",
                    transform: "translateY(-50%)",
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                    padding: 0,
                    color: "#6c757d",
                    fontSize: 18,
                  }}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </InputGroup>
          )}
        />
        <Button
          text={isLoading ? <BeatLoader size={10} /> : "Login"}
          classes={`mt-3 mb-2 ${isLoading ? "bg-dark-subtle" : ""}`}
          type="submit"
          // onClick={handleLogin}
          disabled={isLoading}
        />
      </Form>
      <Description
        text="Forgot Password ?"
        classes="ms-auto cursor-pointer text-black"
        onClick={handleForgotPasswordClick}
      />
    </AccountLayout>
  );
}
